import { Routes } from '@angular/router';
import { AppLayout } from './layout/component/app.layout';
import { RechercherDoComponent } from './components/rechercher-do/rechercher-do.component';
import { GestionDoComponent } from './components/gestion-do/gestion-do.component';
import {ExtractProdComponent} from './components/extract-prod/extract-prod.component';
import { GestionAnnuaireComponent } from './components/gestion-annuaire/gestion-annuaire.component';
import { GestionAstreinteComponent } from './components/gestion-astreinte/gestion-astreinte.component';
import {ExtractClientComponent} from './components/extract-client/extract-client.component';
import {ExtractFacturationComponent} from './components/extract-facturation/extract-facturation.component';
import { GestionContactComponent } from './components/gestion-contact/gestion-contact.component';
import { GestionSocieteComponent } from './components/gestion-societe/gestion-societe.component';
import { GestionInfoComponent } from './components/gestion-info/gestion-info.component';
import { GestionDossierComponent } from './components/gestion-dossier/gestion-dossier.component';
import { ExtractAdminComponent } from './components/extract-admin/extract-admin.component';
import { GestionTraitementComponent } from './components/gestion-traitement/gestion-traitement.component';
import { GestionDesinatairesComponent } from './components/gestion-desinataires/gestion-desinataires.component';

export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        children: [
            // routes pour les pages de l'application
            //{ path: 'dashboard', component: Dashboard },
            //{ path: 'uikit', loadChildren: () => import('./pages/uikit/uikit.routes') },
            //{ path: 'documentation', component: Documentation },
            //{ path: 'pages', loadChildren: () => import('./pages/pages.routes') },
            //{ path: 'test', component: TestComponent },


            // routes pour les pages de l'application
            { path: 'rechercher-do', component: RechercherDoComponent },
            { path: 'extract-prod', component: ExtractProdComponent },
            { path: 'extract-client', component: ExtractClientComponent },
            { path: 'extract-facturation', component: ExtractFacturationComponent },
            { path: 'extract-admin', component: ExtractAdminComponent },
            { path: 'gestion-do', component: GestionDoComponent },
            { path: 'gestion-annuaire', component: GestionAnnuaireComponent },
            { path: 'gestion-astreinte', component: GestionAstreinteComponent },
            { path: 'gestion-societe', component: GestionSocieteComponent },
            { path: 'gestion-contact', component: GestionContactComponent },
            { path: 'gestion-info', component: GestionInfoComponent },
            { path: 'gestion-dossier', component: GestionDossierComponent },
            { path: 'gestion-traitement',component:GestionTraitementComponent},
            { path: 'gestion-destinataires',component:GestionDesinatairesComponent},
            { path: '', redirectTo: 'rechercher-do', pathMatch: 'full' },

        ]
    },
    { path: '**', redirectTo: '' }
];
